import React from 'react';
import { Button, Form, FormControl, InputGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form'
import { AiOutlineSearch } from 'react-icons/ai';
import './index.css'

function LocalizatorForm({ localizator }) {
  const { register, handleSubmit } = useForm();

  return (
    <div className="LocalizatorForm">
      <Form inline className="search" onSubmit={handleSubmit(localizator)}>
        <Form.Label htmlFor="inlineFormInputGroupUsername2" srOnly>
          Localizador
        </Form.Label>
        <InputGroup>
          <InputGroup.Prepend>
            <InputGroup.Text>
              <AiOutlineSearch />
            </InputGroup.Text>
          </InputGroup.Prepend>
          <FormControl
            id="inlineFormInputGroupUsername2"
            placeholder="Digite o código do Localizador..."
            type="text"
            name="cod"
            ref={register}
            required />
        </InputGroup>
        <Button type="submit" className="mb-2">
          Procurar
        </Button>
      </Form>
    </div>
  );
}

export default LocalizatorForm;